import { isEmpty, isNil } from 'lodash';
import { useContext } from 'react';
import { View } from '@shared/components/View';
import { GeolocationMapPreview } from '@shared/components/blocks/lib/inputGeolocation/mapPreview';
import { AddressValue } from '@shared/components/blocks/types';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';
import { isInputComponent } from '../../utils';
import { WorkflowComponentProps } from './WorkflowComponent';
import { WorkflowComponentWrapper } from './WorkflowComponentWrapper';

type AddressData = undefined | AddressValue[];

/*
  TODO
  This component is only used as a readOnly lookup component.
  Will need changes to use in forms. See inputAddress.
*/
export function WorkflowAddressComponent({
  initialData,
  component,
  showLabel,
  paddingHorizontal,
  iconPad,
  showIcon,
}: WorkflowComponentProps) {
  const data = initialData as AddressData;
  const displayableData = data?.filter(d => !isNil(d));

  if (!isInputComponent(component) || isNil(displayableData) || isEmpty(displayableData)) {
    return null;
  }

  const firstAddress = displayableData[0];
  const remainingAddresses = displayableData.slice(1);

  const extraChildren = (
    <>
      <AddressMapPreview address={firstAddress} />
      {remainingAddresses.map((address, index) => (
        <View key={index} marginTop={4} paddingHorizontal={paddingHorizontal}>
          <AddressHeading address={address} />
          <AddressMapPreview address={address} />
        </View>
      ))}
    </>
  );

  return (
    <WorkflowComponentWrapper
      extraChildren={extraChildren}
      // @ts-expect-error -- strict migration
      paddingHorizontal={paddingHorizontal}
      // @ts-expect-error -- strict migration
      iconPad={iconPad}
      component={component}
      // @ts-expect-error -- strict migration
      showLabel={showLabel}
      showIcon={showIcon}
    >
      <AddressHeading address={firstAddress} />
    </WorkflowComponentWrapper>
  );
}

function AddressHeading({ address }: { address: AddressValue }) {
  const colors = useContext(ColorThemeContext);

  return (
    <View paddingBottom={0.5}>
      <MBTextBody1 color={colors.foregroundActive}>{address.title}</MBTextBody1>
      <MBTextBody1 color={colors.foregroundInactive}>{address.subtitle}</MBTextBody1>
    </View>
  );
}

function AddressMapPreview({ address }: { address: AddressValue }) {
  return (
    <View marginTop={2}>
      <GeolocationMapPreview
        lat={address.coords.lat}
        lon={address.coords.lon}
        iconUrl="https://assets.coastapp.com/address-pin.png"
      />
    </View>
  );
}
